import angular from 'angular';
import { EventReceiver } from './EventReceiver';
export const eventReceiver = angular
    .module('eventReceiver', [])
    .config([() => {
        const eventReceiverInstance = new EventReceiver();
        eventReceiverInstance.init();
    }])
    .name;
